import request from '../utils/service';
const api = {
  getIndexNewsList:function(params){
    return request({
      url: '/publicity/v2/api/news/important',
      method: 'get',
      params
  });
  },
    getNewsList:function(params){
      return request({
        url: '/publicity/v2/api/news',
        method: 'get',
        params
    });
    },
    getNewDetail:function(params){
        return request({
            url: '/publicity/v2/api/news/detail',
            method: 'get',
            params
        });
    }
    
};

export default api;